export default __webpack_public_path__ + "static/media/base_phone_1-fs8.b496e1d7.png";